var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_120",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11079",
    "data-name": "Group 11079",
    transform: "translate(-1085 -301)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1085, 301)",
    filter: "url(#Ellipse_120)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-2",
    "data-name": "Ellipse 120",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(9 6)",
    fill: "#437cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11070",
    "data-name": "Group 11070",
    transform: "translate(857.358 -13.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-eye",
    "data-name": "Icon metro-eye",
    d: "M12.189,7.712a10.773,10.773,0,0,0-9.619,6.012,10.7,10.7,0,0,0,19.237,0A10.773,10.773,0,0,0,12.189,7.712ZM16.932,10.9a9.147,9.147,0,0,1,2.807,2.823,9.147,9.147,0,0,1-2.807,2.823,8.815,8.815,0,0,1-9.485,0,9.147,9.147,0,0,1-2.807-2.823A9.147,9.147,0,0,1,7.447,10.9c.074-.047.148-.092.223-.137a4.809,4.809,0,1,0,9.04,0q.112.067.223.137Zm-4.743,1.02a1.8,1.8,0,1,1-1.8-1.8A1.8,1.8,0,0,1,12.189,11.92Z",
    transform: "translate(243.071 323.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chart-bars2",
    "data-name": "Icon metro-chart-bars2",
    d: "M8.707,10.593H5.1a.6.6,0,0,0-.6.6V22.015a.6.6,0,0,0,.6.6H8.707a.6.6,0,0,0,.6-.6V11.195A.6.6,0,0,0,8.707,10.593Zm0,10.821H5.1V16.6H8.707v4.809ZM14.718,8.189H11.112a.6.6,0,0,0-.6.6V22.015a.6.6,0,0,0,.6.6h3.607a.6.6,0,0,0,.6-.6V8.79a.6.6,0,0,0-.6-.6Zm0,13.225H11.112V15.4h3.607v6.012ZM20.73,5.784H17.123a.6.6,0,0,0-.6.6v15.63a.6.6,0,0,0,.6.6H20.73a.6.6,0,0,0,.6-.6V6.385a.6.6,0,0,0-.6-.6Zm0,15.63H17.123V14.2H20.73v7.214Z",
    transform: "translate(252.947 334.519)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/audience.3242316d16fd3faa39544f5ab0420927.svg";
export { ForwardRef as ReactComponent };